import { Shield, Clock, Star, Users, MapPin, Headphones, DollarSign, XCircle } from "lucide-react";
import { motion } from "framer-motion";

const features = [
  { icon: Shield, title: "Safe & Licensed", description: "All our drivers are professionally licensed and vehicles fully insured for your peace of mind." },
  { icon: Clock, title: "Always On Time", description: "We operate around the clock. Early morning or late night flights — we're always ready." },
  { icon: Star, title: "Premium Fleet", description: "From SUVs to luxury vans, travel in comfort and style across the Dominican Republic." },
  { icon: Users, title: "Meet & Greet", description: "Your driver awaits with a sign at the terminal. No confusion, no stress upon arrival." },
  { icon: MapPin, title: "Island-Wide Coverage", description: "Transfers from PUJ, SDQ, STI, LRM, POP & AZS to any hotel or destination." },
  { icon: Headphones, title: "Dedicated Support", description: "Real-time assistance via WhatsApp, phone, or email — anytime you need us." },
  { icon: DollarSign, title: "Fixed Prices", description: "No hidden fees, no surge pricing. Know exactly what you'll pay before you book." },
  { icon: XCircle, title: "Free Cancellation", description: "Plans change — cancel up to 24 hours before your transfer at no cost." },
];

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <p className="text-primary font-semibold text-sm uppercase tracking-widest mb-2">
            Why Choose Us
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground">
            The AOT Difference
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.06 }}
              className="p-6 bg-white rounded-lg border border-border hover:border-primary/30 hover:shadow-md transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <feature.icon className="w-5 h-5 text-primary" />
              </div>
              <h3 className="font-display text-base font-bold text-foreground mb-2">
                {feature.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
